import { ISignInResponse } from 'app/models/response';
import { IUser } from 'app/models/user';
import { serverAxios } from 'app/utils/axios';
import { AxiosResponse } from 'axios';
import { ISignInData } from './models/auth';

class AuthHttp {
  private static route = '/';

  public async signIn(data: ISignInData): Promise<{ user: IUser; token: string }> {
    return serverAxios
      .post(AuthHttp.route, {
        act: 'login',
        query: {
          email: data.email,
          pass: data.password,
        },
        appType: 'admin',
      })
      .then((response: AxiosResponse<ISignInResponse>) => {
        return response.data;
      }).catch((error) => {
        throw error;
      });
  }

  public async refreshToken(token: string): Promise<{token:string}> {
    return serverAxios.post(AuthHttp.route,{
      act: 'refreshtoken',
      token,
    });
  }

}

export default AuthHttp;
